import { ActionBtns, Btn, DDButton, DDContent, ExtraActions, IconWrapper, MoveBtns } from "./сhapter.styles";
import { ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined, DownOutlined, EllipsisOutlined } from "@ant-design/icons";
import Dropdown from "components/atoms/Dropdown/dropdown";
import React, { useState } from "react";
import { useChapterDisplayDataContext } from "contexts/ChapterDisplayContext";
import { useWallDataContext } from "contexts/WallContext";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "hooks";
import Switch from "components/atoms/Switch/switch";
import RemoveIcon from "@assets/icons/remove-red.svg";

export default function ChapterButtons() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const { removeChapter, moveUp, moveDown, hideChapter, chapters, isCreator } = useWallDataContext();
  const {chapter, isCollapsed, openEditor} = useChapterDisplayDataContext();
  const [actionsOpen, setActionsOpen] = useState(false);

  const onEditorOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    openEditor();
    setActionsOpen(false);
  }

  const onDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!chapter.uuid) return;
    removeChapter(chapter.uuid);
  };

  const toggleActions = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setActionsOpen((p) => !p);
  };

  const onMoveUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!chapter.uuid) return;
    moveUp(chapter.uuid);
  };

  const onMoveDown = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!chapter.uuid) return;
    moveDown(chapter.uuid);
  };

  const onHide = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!chapter.uuid) return;
    hideChapter(chapter.uuid);
  };

  const dropdownOnTop = chapters.findIndex(c => c.uuid === chapter.uuid) >= chapters.length - 2;

  return (
    <ActionBtns>
      {chapters.length > 1 && !isMobile && (
        <MoveBtns>
          <Btn onClick={onMoveDown}>
            <ArrowDownOutlined />
          </Btn>
          <Btn onClick={onMoveUp}>
            <ArrowUpOutlined />
          </Btn>
        </MoveBtns>
      )}

      {isCreator && (
        <ExtraActions>
          <Btn style={{ color: "#391D0A" }} onClick={toggleActions}>
            <EllipsisOutlined />
          </Btn>
          <Dropdown top={dropdownOnTop} isOpen={actionsOpen} onClose={() => setActionsOpen(false)}>
            <DDContent>
              <DDButton onClick={onEditorOpen}>{t('wall.edit')}</DDButton>
              {isMobile && <DDButton onClick={onMoveUp}>{t('wall.moveUp')}<ArrowUpOutlined /></DDButton>}
              {isMobile && <DDButton onClick={onMoveDown}>{t('wall.moveDown')}<ArrowDownOutlined /></DDButton>}
              <Switch label={t("wall.hide")} isChecked={chapter.is_hidden} onToggle={onHide} />
              <DDButton style={{color: 'rgba(201, 54, 54, 1)'}} onClick={onDelete}>
                {t('wall.delete')} <img src={RemoveIcon} alt="remove"/>
              </DDButton>
            </DDContent>
          </Dropdown>
        </ExtraActions>
      )}

      <Btn>
        <IconWrapper isOpen={isCollapsed}>
          <DownOutlined />
        </IconWrapper>
      </Btn>
    </ActionBtns>
  );
};
